'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lsamples_Sealed$package$$anon$6$$anon$27() {
}
export { $c_Lsamples_Sealed$package$$anon$6$$anon$27 as $c_Lsamples_Sealed$package$$anon$6$$anon$27 };
$p = $c_Lsamples_Sealed$package$$anon$6$$anon$27.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_Sealed$package$$anon$6$$anon$27;
/** @constructor */
function $h_Lsamples_Sealed$package$$anon$6$$anon$27() {
}
export { $h_Lsamples_Sealed$package$$anon$6$$anon$27 as $h_Lsamples_Sealed$package$$anon$6$$anon$27 };
$h_Lsamples_Sealed$package$$anon$6$$anon$27.prototype = $p;
$p.b = (function() {
  return "<function1>";
});
$p.cq = (function(x$0) {
});
$p.j = (function(v1) {
  return v1;
});
var $d_Lsamples_Sealed$package$$anon$6$$anon$27 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_Sealed$package$$anon$6$$anon$27, "samples.Sealed$package$$anon$6$$anon$27", ({
  qt: 1,
  o: 1,
  a: 1,
  bf: 1
}));
export { $d_Lsamples_Sealed$package$$anon$6$$anon$27 as $d_Lsamples_Sealed$package$$anon$6$$anon$27 };
